// extracted by mini-css-extract-plugin
module.exports = {"container":"Movies_container__2_0bQ"};